import React from 'react';
import img1 from '../img/draw-users.png'
import img2 from '../img/PKN.png'
import img3 from '../img/Portfolio.png'
import img4 from '../img/gallery.png'
import img5 from '../img/PortfolioForClient.png'



const projectsList = [
    {
        id: 1,
        img: img3,
        view:'https://norbertaz.github.io/My-portfolio/',
        source:'https://github.com/norbertaz/My-portfolio',
        title: "Moje portfolio",
    },
    {
        id: 2,
        img: img1,
        view:'https://norbertaz.github.io/draw-users/',
        source:'https://github.com/norbertaz/draw-users',
        title: "Aplikacja losująca użytkownika",
    },
    {
        id: 3,
        img: img2,
        view:'https://norbertaz.github.io/PKN/',
        source:'https://github.com/norbertaz/PKN',
        title: "Papier Kamień nożyce",
    },
    {
        id: 4,
        img: img4,
        view:'https://norbertaz.github.io/Masonry-Gallery/',
        source:'https://github.com/norbertaz/Masonry-Gallery',
        title: "Galeria masonry",
    },
    {
        id: 5,
        img: img5,
        view:'https://norbertaz.github.io/portfolio-Tomek/',
        source:'https://github.com/norbertaz/portfolio-Tomek',
        title: "Portfolio dla klienta",
    },

]

const Projects = () => {
    const projects = projectsList.map(project =>(
        <div className={`project${project.id}`} key={project.id} >
            <h1>{project.title}</h1>
            <img src={project.img} alt="My project"/>
            <a href={project.view} rel="noreferrer noopener">Live</a>
            <a href={project.source} rel="noreferrer noopener">Kod</a>
        </div>
    ))
    return ( 

        <div className="projectWrapper">
            {projects}
        </div>
     );
}
 
export default Projects;